import { cache, loadModule } from '@weareduet/core';
import 'lazysizes';

import Header from '@/globals/Header';
// import SetVh from '@/globals/SetVh';
import CookieBanner from '@/globals/CookieBanner';
import AutoplayVideos from '@/globals/AutoplayVideos';
import FadeIn from '@/globals/FadeIn';
import CardHoverPill from '@/globals/CardHoverPill';
import ScrollSnap from '@/globals/ScrollSnap';

import '@/plugins/logger';
import webfontloader from '@/plugins/webfontloader';
import detectTab from '@/utils/detectTab';
import activeLinks from '@/utils/activeLinks';
import localLinks from '@/utils/localLinks';
import { initSmoothScroll } from '@/utils/lenis';
import { mountScrollIndicator } from '@/utils/scrollIndicator';
import {
	destroyBehavioursWithin,
	destroyModule,
	hydrateBehaviours,
} from '@/utils/sponLifecycle';
import { showMessage, hideMessage } from './ui/messages';

const globalModuleIds = [];

function mountGlobalModule(config) {
	if (cache.has(config.id)) return;

	globalModuleIds.push(config.id);
	loadModule(config);
}

if (import.meta.env.DEV) {
	webfontloader();
	document.documentElement.classList.add('is-dev');
}

// load from data-behaviours
hydrateBehaviours(document.body);

// Smooth scroll (wheel + touch) — interpolates scroll so the scroll-driven
// Approach carousels pass through every beat instead of jumping. Off under
// reduced motion.
initSmoothScroll().then(lenis => {
	// The site's scrollbar: a custom thumb on every device, with the native bar
	// hidden to match (gated on Lenis's `.lenis` root class in CSS). Skipped under
	// reduced motion (lenis is null), which keeps the native bar instead.
	if (lenis) mountScrollIndicator(lenis);
});

mountGlobalModule({
	module: Header,
	id: 'header',
	node: document.getElementById('header'),
	// keepAlive: true,
});

// mountGlobalModule({
// 	module: SetVh,
// 	id: 'set-vh',
// 	node: document.body,
// 	// keepAlive: true,
// });

mountGlobalModule({
	module: AutoplayVideos,
	id: 'body',
	node: document.body,
	// keepAlive: true,
});

mountGlobalModule({
	module: CookieBanner,
	id: 'cookie-baner',
	node: document.body,
	// keepAlive: true,
});

mountGlobalModule({
	module: FadeIn,
	id: 'fade-in',
	node: document.body,
	// keepAlive: true,
});

mountGlobalModule({
	module: CardHoverPill,
	id: 'card-hover-pill',
	node: document.body,
	// keepAlive: true,
});

// mountGlobalModule({
// 	module: ScrollSnap,
// 	id: 'scroll-snap',
// 	node: document.body,
// 	// keepAlive: true,
// });

detectTab();
activeLinks(document.body, window.location.pathname);
localLinks();

function handleBeforeSend() {
	hideMessage();
}

function handleBeforeSwap({ target }) {
	destroyBehavioursWithin(target);
}

function handleAfterSwap({ target }) {
	localLinks(target);
	activeLinks(target, window.location.pathname);
	hydrateBehaviours(target);
}

function handleResponseError() {
	showMessage('Something went wrong, please try again.');
}

// https://htmx.org/events
if (typeof htmx !== 'undefined') {
	htmx.on('htmx:beforeSend', handleBeforeSend);

	// Scroll to top of `sprig` container when interacting; but only when `scroll` is in Param (eg not filtering; but probably pagination)
	htmx.on('htmx:beforeSwap', handleBeforeSwap);

	// Used if sprig target != results; dont' rely on DOM change to remove `.is-loading`
	htmx.on('htmx:afterSwap', handleAfterSwap);

	htmx.on('htmx:responseError', handleResponseError);
}

if (import.meta.hot) {
	import.meta.hot.dispose(() => {
		if (typeof htmx !== 'undefined' && typeof htmx.off === 'function') {
			htmx.off('htmx:beforeSend', handleBeforeSend);
			htmx.off('htmx:beforeSwap', handleBeforeSwap);
			htmx.off('htmx:afterSwap', handleAfterSwap);
			htmx.off('htmx:responseError', handleResponseError);
		}

		destroyBehavioursWithin(document.body);
		globalModuleIds.forEach(id => destroyModule(id));
	});
}
